export default {
  data() {
    return {
      loading: {},
    };
  },
  methods: {
    $startLoading(key) {
      this.$set(this.loading, key, true);
    },
    $stopLoading(key) {
      this.$set(this.loading, key, false);
    },
    $isLoading(key) {
      return this.loading[key];
    },
  },
};
